"use strict";var e=require("tslib");function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=r(require("react"));module.exports=function(r){var a=r.children;return e.__rest(r,["children"]),t.default.createElement("ul",{className:"pagination"},a)};
//# sourceMappingURL=index.js.map
